import React, { useState, useEffect } from 'react';
import './CampaignPopup.css';

const CampaignPopup = ({ onClose, onPlayNow }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    console.log('🎯 CampaignPopup component mounted!');
    // Animate in
    setTimeout(() => {
      console.log('🎯 CampaignPopup animation starting - setting visible to true');
      setIsVisible(true);
    }, 100);
  }, []);

  const handleClose = () => {
    console.log('🎯 CampaignPopup - User clicked close');
    setIsVisible(false);
    setTimeout(onClose, 300);
  };

  const handlePlayNow = () => {
    console.log('🎯 CampaignPopup - User clicked Play Now');
    setIsVisible(false);
    setTimeout(onPlayNow, 300);
  };

  const handleAlreadyParticipated = () => {
    console.log('🎯 CampaignPopup - User marked as already participated');
    // Mark as participated in localStorage
    localStorage.setItem('campaign_participated', 'true');
    handleClose();
  };

  console.log('🎯 CampaignPopup rendering, isVisible:', isVisible);

  return (
    <div className={`campaign-overlay ${isVisible ? 'visible' : ''}`}>
      <div className={`campaign-popup ${isVisible ? 'visible' : ''}`}>
        <button className="campaign-close-btn" onClick={handleClose} aria-label="Close">
          ✕
        </button>

        <div className="campaign-header">
          <div className="campaign-prize">
            <span className="prize-emoji">🏆</span>
            <h2 className="campaign-title">Win up to ₹10,000!</h2>
          </div>
          <p className="campaign-subtitle">Play, Score, Share & Win</p>
        </div>

        <div className="campaign-content">
          <div className="campaign-section">
            <h3 className="section-title">How to Participate</h3>
            <ol className="participation-steps">
              <li>
                <span className="step-number">1</span>
                <span className="step-text">Play Starknet Ninja</span>
              </li>
              <li>
                <span className="step-number">2</span>
                <span className="step-text">Score minimum <strong>1000 points</strong> to be eligible</span>
              </li>
              <li>
                <span className="step-number">3</span>
                <span className="step-text">Share your score tagging on Instagram <strong>@abstractstudio_in</strong> and on X <strong>@AbstractStudioX</strong> with <strong>#starknetninja</strong></span>
              </li>
              <li>
                <span className="step-number">4</span>
                <span className="step-text">Fill up the <a href="https://forms.gle/3naxkf5EJpQgVmW1A" target="_blank" rel="noopener noreferrer" className="form-link">Google Form</a></span>
              </li>
            </ol>
          </div>

          <div className="campaign-section campaign-rules">
            <h3 className="section-title">Rules</h3>
            <ul className="rules-list">
              <li>Public post required with tag and hashtag</li>
              <li>One entry per person; fraudulent entries will be disqualified</li>
            </ul>
          </div>

          <div className="campaign-section campaign-timeline">
            <h3 className="section-title">Timeline</h3>
            <div className="timeline-grid">
              <div className="timeline-item">
                <span className="timeline-label">Starts</span>
                <span className="timeline-date">20 Oct 2025</span>
              </div>
              <div className="timeline-item">
                <span className="timeline-label">Ends</span>
                <span className="timeline-date">27 Oct 2025</span>
              </div>
            </div>
          </div>
        </div>

        <div className="campaign-actions">
          <button className="campaign-btn campaign-btn-primary" onClick={handlePlayNow}>
            <span className="btn-icon"></span>
            Play Now
          </button>
          <button className="campaign-btn campaign-btn-secondary" onClick={handleAlreadyParticipated}>
            Already Participated
          </button>
        </div>
      </div>
    </div>
  );
};

export default CampaignPopup;
